import { AlertTriangle, ArrowRight, Check, Clock3, LogIn, Settings, Trash2 } from 'lucide-react'
import { PageShell } from '../components/SiteChrome'

const steps = [
  [LogIn, 'Log in to the app', 'Open Sandhi Card on your device and sign in to the account you want to remove.'],
  [Settings, 'Open Settings', 'Go to your profile or main menu and choose Settings.'],
  [Trash2, 'Choose Delete Account', 'Scroll to the account section and select Delete Account.'],
  [Check, 'Confirm the request', 'Review the information shown and follow the confirmation prompts.'],
] as const

export function DeleteAccountPage() {
  return (
    <PageShell compactHeader>
      <main className="delete-page">
        <header><div><AlertTriangle /></div><p>Account controls</p><h1>Delete your<br />Sandhi account.</h1><span>You can start the process directly in the mobile app. A 60-day grace period applies before permanent deletion.</span></header>
        <section className="delete-steps"><div className="section-heading"><p>In the Sandhi app</p><h2>Four simple steps</h2></div><div>{steps.map(([Icon, title, text], i) => <article key={title}><span>{String(i + 1).padStart(2, '0')}</span><Icon /><h3>{title}</h3><p>{text}</p></article>)}</div></section>
        <section className="grace-period"><Clock3 /><div><p>About the grace period</p><h2>You have 60 days to change your mind.</h2><span>Your account is scheduled for deletion after the grace period. If you sign back in and the app offers a recovery option before that period ends, you may be able to cancel the request. Once deletion is completed, your cards and account data cannot be restored.</span></div></section>
        <section className="support-card"><p>Can’t access the app?</p><h2>We’ll help you with the next step.</h2><a href="mailto:support@sandhicard.com">Contact support <ArrowRight /></a></section>
      </main>
    </PageShell>
  )
}
